/**
 * @generated SignedSource<<bf5a97450232276c1397546b7b823361>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkedProducts_products$data = ReadonlyArray<{
  readonly id: string;
  readonly imageUrl: string | null;
  readonly name: string | null;
  readonly partNumber: string | null;
  readonly " $fragmentType": "LinkedProducts_products";
}>;
export type LinkedProducts_products$key = ReadonlyArray<{
  readonly " $data"?: LinkedProducts_products$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedProducts_products">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LinkedProducts_products",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "a1c91960b822aa5836cb3591719ec848";

export default node;
